import { Button, ReviewUnit } from "@onegovbugs/onegov-react-components";
import styles from "./reviewApplication.module.scss";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { saveApplication } from "../../redux/actions";
import { RedirectIfCaptchaNotSelected, RedirectIfPrerequisitesNotSelected } from "../../utils/redirect";
import ScrollToTop from "../../utils/scrollToTop";

const ReviewApplication = props => {
  RedirectIfCaptchaNotSelected(props);
  RedirectIfPrerequisitesNotSelected(props);

  ScrollToTop();

  const dispatch = useDispatch();

  const tattooistDetails = useSelector((state) => state.tattooistDetails);
  const twoFA = useSelector((state) => state.twoFA);
  const applicantDetails = useSelector((state) => state.applicantDetails);
  const employment = useSelector((state) => state.employment);
  const disclosures = useSelector((state) => state.disclosures);
  const collectionOfLicence = useSelector((state) => state.collectionOfLicence);
  const documents = useSelector((state) => state.documents);

  const [duration] = useState(tattooistDetails ? tattooistDetails.duration : '');

  const [twoFAData] = useState(twoFA ? twoFA.data : { firstName: "", lastName: "", day: "", month: "", year: "" });

  const [placeOfBirth] = useState(applicantDetails ? applicantDetails.placeOfBirth : { country: "", state: "", town: "" });
  const [identificationDetails] = useState(applicantDetails ? applicantDetails.identificationDetails : { cardNumber: "", stateIssued: "" });
  const [contactPart] = useState(applicantDetails ? applicantDetails.contactPart : { emailAddress: "", mobileNo: "", phoneNo: "" });
  const [addressResidential] = useState(applicantDetails ? applicantDetails.addressResidential : null);
  const [addressPostal] = useState(applicantDetails ? applicantDetails.addressPostal : null);
  const [otherNames] = useState(applicantDetails ? applicantDetails.otherNames : null);

  const [employmentFlag] = useState(employment ? employment.employmentFlag : "");
  const [employmentHistory] = useState(employment ? employment.employmentHistory : []);

  const [applicationEverRefused] = useState(disclosures ? disclosures.applicationEverRefused : '');
  const [applicationEverRefusedComment] = useState(disclosures ? disclosures.applicationEverRefusedComment : '');
  const [heldSuspendedDocument] = useState(disclosures ? disclosures.heldSuspendedDocument : '');
  const [heldSuspendedDocumentComment] = useState(disclosures ? disclosures.heldSuspendedDocumentComment : '');
  const [disciplinaryAgainstYou] = useState(disclosures ? disclosures.disciplinaryAgainstYou : '');
  const [disciplinaryAgainstYouComment] = useState(disclosures ? disclosures.disciplinaryAgainstYouComment : '');
  const [disqualifiedToHoldLicence] = useState(disclosures ? disclosures.disqualifiedToHoldLicence : '');
  const [disqualifiedToHoldLicenceComment] = useState(disclosures ? disclosures.disqualifiedToHoldLicenceComment : '');

  const [centreLocation] = useState(collectionOfLicence && collectionOfLicence.centreLocation ? collectionOfLicence.centreLocation.label : '');

  const [filesQualification] = useState(documents ? JSON.parse(documents.filesQualification) : []);
  const [qualificationDescription] = useState(documents ? documents.qualificationDescription : '');
  const [filesTrade] = useState(documents ? JSON.parse(documents.filesTrade) : []);
  const [tradeDescription] = useState(documents ? documents.tradeDescription : '');

  //Logics to get Addresses

  const manaulResidential = addressResidential ? addressResidential.manualAddress : null;

  const addressResidentialFinal = (addressResidential ? (addressResidential.enterManually == true) ? (
    (!manaulResidential.propertyName || manaulResidential.propertyName == "" ? "" : manaulResidential.propertyName + ", ") +
    (!manaulResidential.unitNo || manaulResidential.unitNo == "" ? "" : manaulResidential.unitNo + ", ") +
    (!manaulResidential.streetNoStart || manaulResidential.streetNoStart == "" ? "" : manaulResidential.streetNoStart + ", ") +
    (!manaulResidential.streetNoEnd || manaulResidential.streetNoEnd == "" ? "" : manaulResidential.streetNoEnd + ", ") +
    (!manaulResidential.streetName || manaulResidential.streetName == "" ? "" : manaulResidential.streetName) +
    (!manaulResidential.streetType || manaulResidential.streetType == "" ? ", " : " " + manaulResidential.streetType + ", ") +
    //manaulResidential.streetType + (manaulResidential.streetType==""?"":", ")+
    (!manaulResidential.suburb || manaulResidential.suburb == "" ? "" : manaulResidential.suburb + ", ") +
    (!manaulResidential.state || manaulResidential.state == "" ? "" : manaulResidential.state + ", ") +
    manaulResidential.postCode
  )
    : (
      addressResidential.details.Address.PartialAddress + ", " + addressResidential.details.Address.Country
    )
    : '');

  //const manaulPostal = addressPostal.manualAddress1 ;
  const manaulPostal = addressPostal ? addressPostal.manualAddress : null;

  const addressPostalFinal = (addressPostal ? (addressPostal.enterManually == true) ? (
    (!manaulPostal.propertyName || manaulPostal.propertyName == "" ? "" : manaulPostal.propertyName + ", ") +
    (!manaulPostal.unitNo || manaulPostal.unitNo == "" ? "" : manaulPostal.unitNo + ", ") +
    (!manaulPostal.streetNoStart || manaulPostal.streetNoStart == "" ? "" : manaulPostal.streetNoStart + ", ") +
    (!manaulPostal.streetNoEnd || manaulPostal.streetNoEnd == "" ? "" : manaulPostal.streetNoEnd + ", ") +
    (!manaulPostal.streetName || manaulPostal.streetName == "" ? "" : manaulPostal.streetName) +
    (!manaulPostal.streetType || manaulPostal.streetType == "" ? ", " : " " + manaulPostal.streetType + ", ") +
    //manaulPostal.streetType + (manaulPostal.streetType==""?"":", ")+
    (!manaulPostal.suburb || manaulPostal.suburb == "" ? "" : manaulPostal.suburb + ", ") +
    (!manaulPostal.state || manaulPostal.state == "" ? "" : manaulPostal.state + ", ") +
    manaulPostal.postCode
  )
    : (
      addressPostal.details.Address.PartialAddress + ", " + addressPostal.details.Address.Country
    )
    : '');


  const jsxTattooistDetails = (
    <ReviewUnit
      title={"Duration"}
      onEdit={() => props.history.push("/tattooist-form/duration")}
    >
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div className={styles.camelCase}>{duration}</div>
        </div>
      </div>
    </ReviewUnit>
  );

  const jsxApplicantDetails = (
    <ReviewUnit
      title={"Applicant Details"}
      onEdit={() => props.history.push("/tattooist-form/applicant-details")}
    >
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Full name</em>
          </div>
          <div className={styles.camelCase}>{(twoFAData ? twoFAData.firstName : "") + " " + (twoFAData ? twoFAData.lastName : "")}</div>
        </div>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Country of Birth</em>
          </div>
          <div className={styles.camelCase}>{placeOfBirth.country}</div>
        </div>
      </div>
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>If born in Australia, Town</em>
          </div>
          <div className={styles.camelCase}>{placeOfBirth.town}</div>
        </div>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>If born in Australia, State</em>
          </div>
          <div className={styles.camelCase}>{placeOfBirth.state}</div>
        </div>
      </div>
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Driver licence/photo card number</em>
          </div>
          <div className={styles.camelCase}>{identificationDetails.cardNumber}</div>
        </div>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Driver licence/photo card - state issued</em>
          </div>
          <div className={styles.camelCase}>{identificationDetails.stateIssued}</div>
        </div>
      </div>
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Date of Birth</em>
          </div>
          <div>{(twoFAData ? twoFAData.day + "/" + twoFAData.month + "/" + twoFAData.year : "")}</div>
        </div>

        <div className={"col-12 col-md-6"}>
          <div>
            <em>Email</em>
          </div>
          <div>{contactPart.emailAddress}</div>
        </div>
      </div>

      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Mobile Telephone Number</em>
          </div>
          <div>{contactPart.mobileNo}</div>
        </div>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Daytime Telephone Number</em>
          </div>
          <div>{contactPart.phoneNo}</div>
        </div>
      </div>
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Residential Address</em>
          </div>
          <div>{addressResidentialFinal}</div>
        </div>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Postal Address</em>
          </div>
          <div>{addressPostalFinal}</div>
        </div>
      </div>
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>Other names</em>
          </div>
          {
            <div className={styles.camelCase}>
              {otherNames && otherNames.length > 0 && otherNames.map((ol, i) => (
                <>
                  <span>
                    {ol.firstName + " " + (ol.middleName ? ol.middleName + " " : ol.middleName) + ol.lastName}
                  </span>
                  <br />
                </>
              ))
              }
            </div>
          }
          {
            (otherNames === null || otherNames.length == 0 &&
              <p>N/A</p>
            )
          }
        </div>
      </div>
    </ReviewUnit>
  );

  const jsxEmployment = (
    <ReviewUnit
      title={"Evidence of Employment"}
      onEdit={() => props.history.push("/tattooist-form/employment")}
    >
      {
        employmentFlag != "yes" ? (
          <div className={`row ${styles.infoLine}`}>
            <div className={"col-12 col-md-6"}>
              No employment details added
          </div>
          </div>
        ) :
          (
            employmentHistory.map((el, i) => (

              <div key={"employment-" + i} >
                {i != 0 && (<hr className={styles.hrEmployment} />)}
                <div className={`row ${styles.infoLine}`}>
                  <div className={"col-12 col-md-6"}>
                    <div>
                      <em>Full name</em>
                    </div>
                    <div>{el.name}</div>
                  </div>
                  <div className={"col-12 col-md-6"}>
                    <div>
                      <em>Phone Number</em>
                    </div>
                    <div>{el.phoneNumber}</div>
                  </div>
                </div>
                <div className={`row ${styles.infoLine}`}>
                  <div className={"col-12 col-md-6"}>
                    <div>
                      <em>Start Date</em>
                    </div>
                    <div>{el.dayOfCommenced + "/" + el.monthOfCommenced + "/" + el.yearOfCommenced}</div>
                  </div>
                  <div className={"col-12 col-md-6"}>
                    <div>
                      <em>End Date</em>
                    </div>
                    <div>{el.currentEmployment == 1 ? 'Current Employment' : el.dayOfFinished + "/" + el.monthOfFinished + "/" + el.yearOfFinished}</div>
                  </div>
                </div>
                <div className={`row ${styles.infoLine}`}>
                  <div className={"col-12 col-md-6"}>
                    <div>
                      <em>Position</em>
                    </div>
                    <div>{el.position}</div>
                  </div>
                </div>
              </div>
            ))
          )
      }

    </ReviewUnit>
  );

  const jsxDisclosures = (
    <ReviewUnit
      title={"Disclosures"}
      onEdit={() => props.history.push("/tattooist-form/disclosures")}
    >
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>
              Have you ever had an application for a tattoo industry licence/permit refused?
            </em>
          </div>
          <div className={styles.camelCase}>
            {applicationEverRefused === 'yes' ? `Yes. ${applicationEverRefusedComment}` : 'No'}
          </div>
        </div>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>
              Have you ever had a tattoo industry licence/permit suspended, cancelled or revoked in New South Wales or elsewhere?
            </em>
          </div>
          <div className={styles.camelCase}>{heldSuspendedDocument === 'yes' ? `Yes. ${heldSuspendedDocumentComment}` : 'No'}</div>
        </div>
      </div>
      <div className={`row ${styles.infoLine}`}>
      <div className={"col-12 col-md-6"}>
          <div>
              <em>
                  Are you disqualified from holding a tattoo industry licence/permit in New South Wales or elsewhere? 
              </em>
          </div>
          <div className={styles.camelCase}>{disqualifiedToHoldLicence === 'yes' ? `Yes. ${disqualifiedToHoldLicenceComment}` : 'No'}</div>
        </div>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>
              Within the last 10 years, have you been to court in New South Wales or elsewhere and been convicted of an offence? 
            </em>
          </div>
          <div className={styles.camelCase}>{disciplinaryAgainstYou === 'yes' ? `Yes. ${disciplinaryAgainstYouComment}` : 'No'}</div>
        </div>
      </div>
    </ReviewUnit>
  );

  const jsxCollectionOfLicence = (
    <ReviewUnit
      title={"Collection of Licence"}
      onEdit={() => props.history.push("/tattooist-form/collection-of-licence")}
    >
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12 col-md-6"}>
          <div>
            <em>
              Motor Registry Name
            </em>
          </div>
          <div>{centreLocation}</div>
        </div>
      </div>
    </ReviewUnit>
  );

  const jsxProofOfIdentity = (
    <><ReviewUnit
      title={"Proof of Identity"}
      onEdit={() => props.history.push("/tattooist-form/upload-documents")}
    >
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12"}>
          <div>
            <em>
              Uploaded Documents
            </em>
          </div>
        </div>
      </div>
      <hr />
      <br />
      <div className={`row ${styles.infoLine}`}>
        <div className={"col-12"}>
          {
            filesQualification.filter(e => e.status === 'done').map((el, i) => (
              <div className={styles.fileList} key={"qualificationFile-" + i} >
                {(i > 0 && <><br /><hr /><br /></>)}
                <p>{el.name}</p>
                <p>{el.description}</p>
              </div>
            ))
          }
          {
            (filesQualification.length == 0 &&
              <p>No document attached</p>
            )
          }

        </div>
      </div>
    </ReviewUnit>
  </>
  );

  return (
    <div className={styles.mainCont}>
      <p>
        Please check the information you have entered in this application. If
        you need to correct any of the details, click 'Back' or select the
        relevant section and change the information as appropriate. To proceed
        with the application click 'Next'.
      </p>
      {jsxTattooistDetails}
      {jsxApplicantDetails}
      {jsxEmployment}
      {jsxDisclosures}
      {jsxProofOfIdentity}
      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              props.history.push(`./declaration`);
            }}
          >
            Confirm
          </Button>
          <Button
            secondary
            onClick={() => {
              dispatch(
                saveApplication("step7", () => {
                  window.location.href = `${process.env.REACT_APP_BAU_URL}`;
                })
              );
            }}
          >
            Save & exit section
        </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(props => <ReviewApplication {...props} />);
